import { render } from "./IconPaperClip.vue?vue&type=template&id=202ffd19"
const script = {}
script.render = render

export default script